<template>
  <VBtn prepend-icon="mdi-plus" color="primary" elevation="10" v-bind="$attrs">
    <slot>
      {{ props.title || t('addNew') }}
    </slot>
    <template v-slot:loader>
      <ProgressBar size="24" width="2" />
    </template>
  </VBtn>
</template>

<script setup>
import i18n from '@/plugins/i18n';
import { useThemeConfig } from '@/composables/useThemeConfig';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
});
const { t } = i18n.global;
const { theme } = useThemeConfig();
const isDark = computed(() => theme.value === 'dark');
</script>
